import { Form } from 'react-final-form'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import LinearProgress from '@material-ui/core/LinearProgress';
import arrayMutators from 'final-form-arrays'
import Fab from '@material-ui/core/Fab'
import Icon from '@material-ui/core/Icon'
import {
  SortableContainer,
  SortableItem,
  SortableDragHandle,
} from 'components/Sortable';
import arrayMove from 'array-move';

import AutoSave from 'components/AutoSave'

import PersonalDetails from 'layouts/FormLayout/sections/PersonalDetails'
import Links from 'layouts/FormLayout/sections/Links'
import Employment from 'layouts/FormLayout/sections/Employment'
import Education from 'layouts/FormLayout/sections/Education'
import Skills from 'layouts/FormLayout/sections/Skills'
import ThemeManagement, { ThemesConfig } from 'layouts/FormLayout/sections/ThemeManagement'
import Summary from 'layouts/FormLayout/sections/Summary'
import Languages from 'layouts/FormLayout/sections/Languages'
import Hobby from 'layouts/FormLayout/sections/Hobby'
import Approval from 'layouts/FormLayout/sections/Approval'

import CustomScroll from 'react-custom-scroll';
import { downloadPdf } from 'api'
import Button from '@material-ui/core/Button'

import { required, isEmail, composeValidators } from 'helpers/Validators'
import {
  getSavedFormData,
  saveFormDataInDb,
  recalculateCompleteness,
  saveSectionsOrderInDb,
  getSectionsOrderFromDb
} from 'helpers/FormDbManager'
import { getPreview } from 'api'

const FormContainer = styled.div`
  position: relative;
  padding: 0.5rem;
  color: #98a1b3;
  font-family: 'Poppins';
  background: white;
`

const CompletenessLabel = styled.div`
  margin: 0 12px;
  font-weight: 400;
  text-align: left;
  color: #98a1b3;
  font-size: 12px;
  text-transform: 'uppercase';
`

const StyledLinearProgress = styled(LinearProgress)`
  margin: 4px 12px 20px 12px;
  background: #ECEDF4;
  height: 1px;
`

const formConfig = {
  resumeLanguage: {},
  template: {
  },
  themeColor: {
  },
  firstName: {
    completeness: 5,
    validate: composeValidators(
      required
    ),
  },
  lastName: {
    completeness: 5,
    validate: composeValidators(
      required
    ),
  },
  phone: {
    completeness: 5,
    validate: composeValidators(
      required
    ),
  },
  email: {
    completeness: 5,
    validate: composeValidators(
      isEmail, required
    )
  },
  picture: {
    completeness: 10
  },
  summary: {
    completeness: 10,
    validate: composeValidators(
      required
    ),
  },
  links: {
    completeness: 10
  },
  employment: {
    completeness: 10
  },
  education: {
    completeness: 10
  },
  hobby: {
    completeness: 10
  },
  languages: {
    completeness: 10
  },
  skills: {
    completeness: 10
  },
  approval: {},
  sortableValues: {}
}

const MainContainer = styled.main`
  position: relative;
  flex: 1;
  background: #FFFFFF;
  height: 100vh;

  @media screen and (min-width: 1280px) {
    max-width: 960px;
  }
`

const ContentWrapper = styled.div`
  position: relative;
  #padding: 0 80px 0 80px;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 25px !important;
`

const CustomIcon = styled(Icon)`
  font-size: 3rem;
  color: white;
`

const DownloadBttn = styled(Button)`
color: white !important;
margin: 170px 10px 40px 0 !important;
background-color: #ff6900 !important;
position: inherit !important;
z-index: 2;
float: right;

  @media screen and (max-width: 1024px)
  {
    margin: 50px 10px 40px 0 !important;    
  }
`

const ShowPreviewButton = styled(Fab)`
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  width: 5rem;
  height: 5rem;
  ${({disable}) => `
    background-color: ${disable ? 'rgba(0, 0, 0, 0.3)' : 'rgba(33, 150, 243, 0.8)'};
    &:hover {
      background-color: ${disable ? 'rgba(0, 0, 0, 0.3)' : 'rgba(33, 150, 243, 1)'};
    }
  `}
  @media screen and (min-width: 1280px) {
    display: none;
  }
`

const FormWrapper = styled.div`
  position: relative;
  top: 164px;
  @media screen and (max-width: 1024px) {
    top: 0px !important;
  }
`

let settingInitialDataDone = false;
const sortableSectionsConfig = [
  {
    formFieldName: 'links',
    component: Links
  },
  {
    formFieldName: 'employment',
    component: Employment
  },
  {
    formFieldName: 'education',
    component: Education
  },
  {
    formFieldName: 'skills',
    component: Skills
  },
  {
    formFieldName: 'languages',
    component: Languages
  },
  {
    formFieldName: 'hobby',
    component: Hobby
  }
]

let previousTemplate = null;

const defaultState = {
  completed: 0,
  formData: {},
  requestData: {},
  initialFormData: {
    approval: `<p>Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb rekrutacji (zgodnie z art. 6 ust. 1 lit. a Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE).</p>`
  },
  formValid: false,
  sectionsOrder: sortableSectionsConfig
}

function FormLayout ({
  db,
  onSave,
  openModal
}) {
  const [state, setSt] = useState(defaultState);

  const setState = (newState) => {
    setSt({
      ...state,
      ...newState
    })
  }

  const {
    completed,
    formData,
    requestData,
    initialFormData,
    formValid,
    sectionsOrder
  } = state

  useEffect(
    () => {
      try {
        db.version(1).stores({
          formData: 'id,value',
          sectionOrder: 'id, sectionOrder'
        })
        if (!settingInitialDataDone) {
          getSavedFormData(db, formConfig, (initialFormData) => {
            setState({
              initialFormData
            })
          })
          getSectionsOrderFromDb(db, (sectionsOrder) => {
            if (sectionsOrder && sectionsOrder.length > 0) {
              setState({
                sectionsOrder: [...sectionsOrder]
              })
            }
          })
          settingInitialDataDone = true
        }
      } catch(err) {
        console.log(err)
      }
    },
    [db]
  )

  useEffect(
    () => setState({ completed: recalculateCompleteness({formData, formConfig}) }),
    [formData]
  )

  useEffect(() => {
    save(formData, formValid)
  }, [sectionsOrder])

  const reselectTemplateColorOnChange = (formData) => {
    if (formData.template) {
      if (previousTemplate !== formData.template) {
        const choosenTemplate = ThemesConfig.find(t => t.value === formData.template)
        formData.themeColor = choosenTemplate.themeColors[0].value
      }
      previousTemplate = formData.template
    }
    return formData
  }

  const save = async (formData, formValid) => {
    reselectTemplateColorOnChange(formData)
    console.log('save formData', formData)
    if (Object.keys(formData).length > 0){
      saveFormDataInDb(db, formData)
  
      const sortableValues = sectionsOrder.map((s) => ({
        fieldName: s.formFieldName,
        values: formData[s.formFieldName] || null
      }))
      console.log('sortableValues', sortableValues)

      const requestData = {
        ...formData,
        sortableValues,
      }
      setState({
        formData,
        formValid,
        requestData
      })
  
      const preview = await getPreview({
        ...requestData,
        picture: null,
      })
      
      onSave && onSave(preview, requestData, formValid)
    }
  }
  

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newSectionsOrder = [...arrayMove(sectionsOrder, oldIndex, newIndex)]
    setState({
      sectionsOrder: newSectionsOrder
    })
    saveSectionsOrderInDb(db, newSectionsOrder)
  };

  const GenerateIcon = () => (<CustomIcon>cloud_download</CustomIcon>)

  const renderForm = ({
    handleSubmit,
    form: {
      mutators
    },
    submitting,
    pristine,
    values,
    reset,
    valid
  }) => {
    return (
      <FormContainer>
        <AutoSave debounce={300} save={save} />
        <ThemeManagement values={values}/>
        <PersonalDetails />
        <Summary />
        <SortableContainer
          onSortEnd={onSortEnd}
          useDragHandle
          pressThreshold={100}
          disableAutoscroll
        >
          {sectionsOrder.map((s, index) => (
            <SortableItem
              key={`item-${index}`}
              index={index}
            >
                <s.component
                  mutators={mutators}
                  index={index}
                />
            </SortableItem>
          ))}
        <Approval />
        </SortableContainer>
      </FormContainer>
    )
  }

  return (
    <MainContainer>
      <ContentWrapper className="editor">
        <CustomScroll heightRelativeToParent="100%">
          <div className="top-wrapper">
            <div className="top">
              <h1>Kreator CV</h1>
              <CompletenessLabel>Postęp <div className="bold">Ukończono</div> <div className="orange"> {completed}%</div> </CompletenessLabel>
              <StyledLinearProgress variant='determinate' value={completed} />
            </div>
          </div>
          
          <div className="formWrapper">
            <FormWrapper>
              <Form
                onSubmit={save}
                mutators={{
                  ...arrayMutators
                }}
                initialValues={initialFormData}
                render={renderForm}
              />
            </FormWrapper>
            <DownloadBttn
              variant="contained"
              size="large"
              onClick={async() => {
                await downloadPdf(requestData, formValid)
              }}
            >
              Pobierz plik PDF
            </DownloadBttn>
          </div>
        </CustomScroll>
      </ContentWrapper>

    </MainContainer>
  )
}

export default FormLayout